import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Asset_AssetType } from "../../content/asset";
import { MediaSource } from "../../content/media_source";
export const protobufPackage = "snapchat.cdp.cof";
export interface MdpMediaAttribution {
    mediaSource: MediaSource;
    assetType: Asset_AssetType;
}
function createBaseMdpMediaAttribution(): MdpMediaAttribution {
    return { mediaSource: 0, assetType: 0 };
}
export const MdpMediaAttribution: MessageFns<MdpMediaAttribution> = {
    encode(message: MdpMediaAttribution, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.mediaSource !== 0) {
            writer.uint32(8).int32(message.mediaSource);
        }
        if (message.assetType !== 0) {
            writer.uint32(16).int32(message.assetType);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): MdpMediaAttribution {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMdpMediaAttribution();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.mediaSource = reader.int32() as any;
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.assetType = reader.int32() as any;
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<MdpMediaAttribution>, I>>(base?: I): MdpMediaAttribution {
        return MdpMediaAttribution.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<MdpMediaAttribution>, I>>(object: I): MdpMediaAttribution {
        const message = createBaseMdpMediaAttribution();
        message.mediaSource = object.mediaSource ?? 0;
        message.assetType = object.assetType ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
